module.exports = __webpack_public_path__ + "static/media/poll-h.f7bedd69.svg";